import { createContext, useContext } from "react"

export interface Selection {
  /**
   * The logical id of the content to select.
   */
  id?: string

  /**
   * Update the current selection.
   */
  update: (requestedFrom: SelectionArea, newId: string) => void
}

export type SelectionArea = "sliceTable" | "sliceFieldSet"

export function getSelectionDOMId(area: SelectionArea, id?: string) {
  if (!id) return undefined
  return `${area}___${id}`
}

export const SelectionContext = createContext<Selection>({
  update: () => {}
})

interface UseSelectionArgs {
  /**
   * Initial slice key.
   * Used to determine if the slice is selected.
   * @param {string} sliceKey
   */
  sliceKey?: string
}

export function useSelection(args?: UseSelectionArgs) {
  const { sliceKey } = args || {}
  const selection = useContext(SelectionContext)
  const selectionId = getSelectionDOMId("sliceFieldSet", sliceKey)
  const selected = sliceKey === selection?.id

  return {
    selectionId,
    selected,
    selection
  }
}
